import JourneyLeg from '@models/JourneyLeg'

export const addJourneyLeg = (data) => {
  return JourneyLeg.insert(data)
}

export const updateJourneyLeg = (data) => {
  return JourneyLeg.update(data)
}

export const deleteJourneyLeg = (filter) => {
  return JourneyLeg.delete(filter)
}

export const deleteAllJourneysLegs = () => {
  return JourneyLeg.deleteAll()
}
